import { render, staticRenderFns } from "./ScreenSolicitud.vue?vue&type=template&id=bb7795de"
import script from "./ScreenSolicitud.vue?vue&type=script&lang=js"
export * from "./ScreenSolicitud.vue?vue&type=script&lang=js"
import style0 from "./ScreenSolicitud.vue?vue&type=style&index=0&id=bb7795de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports